// extracted by mini-css-extract-plugin
export default {"phone":"styles_phone__nbWti"};